<template>
  <base-dialog-confirmation
    :model-value="boundValue"
    @update:model-value="emitBoundValue"
    :prompt="prompt"
    :confirm-text="removeText"
    confirm-color="red"
    @confirm="confirm"
    @cancel="cancel"
  ></base-dialog-confirmation>
</template>

<script>
import modelValueCompat from '@/mixins/modelValueCompat';

export default {
  name: 'BaseDialogDeleteConfirmation',

  mixins: [modelValueCompat],

  inheritAttrs: false,

  props: {
    prompt: {
      type: String,
      default: "Do you really want to do this?",
    },
    removeText: {
      type: String,
      default: "Remove",
    },
  },

  emits: ['update:modelValue', 'input', 'removed'],

  methods: {

    confirm: function () {
      this.$emit('removed', this.boundValue);
    },

    cancel: function () {
      this.emitBoundValue(null);
    },

  },
};
</script>
